
import { ArrowLeft, CheckCircle2, Award, Building2, Users } from "lucide-react";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";
import './Marutiply.css';

const Marutiply = () => {
  const navigate = useNavigate();

  return (
    <div className="mp-page">
      {/* Header */}
      <div className="mp-header">
        <div className="container">
        <nav className="nav-bar" data-testid="main-navigation">
        <div className="nav-container">
          <div className="nav-logo" data-testid="company-logo">
            <img src={require('src/images/MarutiGroupLogo.jpg')} alt="Maruti Group Logo" className="w-10 h-10" />
            <span className="logo-text">MARUTI GROUP</span>
              </div>
            </div>
          </nav>
        </div>
        <Button
          variant="ghost"
          onClick={() => navigate("/")}
          className="back-btn"
        >
          <ArrowLeft className="mr-2 w-5 h-5" />
          Back to Home
        </Button>
      </div>

      {/* Hero Section */}
      <section className="mp-hero">
        <div className="mp-hero-content">
          <div className="mp-hero-text">
            <div className="orange-accent"></div>
            <h1 className="mp-title">Trusted Plywood Brands Under One Roof</h1>
            <div className="mp-subtitle-box">
              <h2 className="mp-subtitle">Maruti Ply</h2>
            </div>
            <p className="mp-description">
              Maruti Ply is one of the newest ventures under the Maruti Group of Companies, launched to meet the rising demands of the construction and interior furnishing industry. With a strong emphasis on quality, durability and modern design, Maruti Ply provides a wide range of premium products suitable for residential, commercial, and industrial applications.
            </p>
          </div>
          <div className="mp-hero-image">
            <div className="blue-circle"></div>
            <img 
               src={require('src/images/MarutiPly8.jpg')}
              alt="Plywood Hero"
              className="plywood-image"
            />
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="mp-products">
        <div className="mp-products-content">
          <div className="mp-products-image">
            <img 
               src={require('src/images/MarutiPly5.jpg')}
              alt="Plywood Products"
            />
          </div>
          <div className="mp-products-text">
            <div className="orange-bar"></div>
            <h2 className="mp-section-title orange-text">Key Products We Offer:</h2>
            <ul>
              <li><strong>Plywood:</strong> High-quality, durable plywood ideal for furniture, interior work and structural applications.</li>
              <li><strong>Laminates:</strong> Stylish and versatile laminate sheets available in multiple designs and finishes for modern interiors.</li>
              <li><strong>Block Board:</strong> Strong and dimensionally stable block boards suitable for doors, partitions and heavy-duty furniture.</li>
              <li><strong>WPC Ply:</strong> Weatherproof and long-lasting Wood Plastic Composite boards, perfect for moisture-prone and termite-prone areas.</li>
              <li><strong>Hardware:</strong> A wide assortment of essential hardware items to support complete construction and interior needs.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Brands Section */}
      <section className="mp-brands">
        <div className="container">
          <h2 className="section-title">Brands We Deal With:</h2>
          <div className="mp-brands-grid">
            <div className="mp-brand-card">
              <h3>Plywood</h3>
              <p>Greenply, Alishan, Swadesh</p>
            </div>
            <div className="mp-brand-card">
              <h3>Laminates</h3>
              <p>Greenlam, Black Cobra, Advance</p>
            </div>
            <div className="mp-brand-card">
              <h3>Hardware</h3>
              <p>Godrej, Hettich</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="mp-stats">
        <div className="container">
          <h2 className="section-title">Our Achievements</h2>
          <div className="mp-stats-grid">
            <div className="mp-stat-card">
              <Users className="stat-icon" />
              <div className="stat-value">50+</div>
              <div className="stat-label">Satisfied Customers</div>
            </div>
            <div className="mp-stat-card">
              <Building2 className="stat-icon" />
              <div className="stat-value">5</div>
              <div className="stat-label">Major Brands</div>
            </div>
            <div className="mp-stat-card">
              <Award className="stat-icon" />
              <div className="stat-value">2+</div>
              <div className="stat-label">Years of Experience</div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="mp-features">
        <div className="container">
          <h2 className="section-title">Why Choose Maruti Ply?</h2>
          <div className="mp-features-grid">
            <div className="mp-feature-card">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Reliability</h3>
              <p>All products are carefully sourced and manufactured for long life and structural strength.</p>
            </div>
            <div className="mp-feature-card">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Aesthetic Appeal</h3>
              <p>Modern designs and finishes to suit every interior and construction need.</p>
            </div>
            <div className="mp-feature-card">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Superior Craftsmanship</h3>
              <p>Exceptional quality and customer satisfaction guaranteed.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="mp-cta">
        <div className="container">
          <div className="mp-cta-content">
            <h2>Ready to Build with the Best?</h2>
            <p>Contact us today to learn more about our products and brands.</p>
            <Button 
              size="lg" 
              className="cta-btn"
              onClick={() => navigate("/#contact")}
            >
              Get in Touch
            </Button>
          </div>
        </div>
      </section>

       {/* Footer */}
      <footer className="footer" data-testid="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src={require('src/images/MarutiGroupLogo.jpg')} alt="Maruti Group Logo" className="w-10 h-10" />
              <span>MARUTI GROUP</span>
            </div>
            <p className="footer-text">
              Building sustainable futures since 1987. Committed to quality, innovation, and customer satisfaction.
            </p>
          </div>
          <div className="footer-bottom">
            <p>© 2025 Maruti Group. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Marutiply;
